<template>
  <div class="cmp-accounting-invoices-invoice_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddInvoiceClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            :title="$t('add_invoice')"
            :alt="$t('add_invoice')"
          />
        </div>
      </div>
      <div class="search">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        />

        <Dropdown
          style="min-width: 180px; margin-right: 20px; margin-left: 20px"
          :options="invoice_projectsTV"
          :selected="
            invoice_projectsTV.find(
              (ip) => ip.value == basicFilter.invoice_project_id
            )
          "
          :placeholder="$dft.capHead($t('select_invoice_project'))"
          :title="$dft.capHead($t('select_invoice_project'))"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
        />

        <Dropdown
          style="min-width: 180px; margin-right: 20px"
          :options="usersTV"
          :selected="
            usersTV.find((u) => u.value == basicFilter.invoice_user_id)
          "
          :placeholder="
            $t('select_user')
          "
          :title="$t('select_user')"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('invoice_user_id', e)"
        />
        <Dropdown
          style="min-width: 180px; margin-right: 20px"
          :options="inv_statTV"
          :selected="
            inv_statTV.filter((is) =>
              basicFilter.invoiceStatuses.split(',').includes(is.value)
            )
          "
          :placeholder="
            $t('select_status')
          "
          :title="$t('select_status')"
          multiple
          allnone
          borderbottom
          v-on:selectedChange="
            (e) => onMultiDropdownChange('invoiceStatuses', e)
          "
          :listHeight="260"
        />
        <DTIconButton
          :classNames="'search--advanced'"
          :text="$t('advanced_search')"
          :style="{
            minWidth: '148px',
            maxWidth: '148px',
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
        <!-- <button
          style="margin-top: 8px; margin-left: 0px"
          class="dt-button v5 s8"
          @click="refresh"
        >
          {{ $t("refresh") }}
        </button> -->
        <div class="right-space"></div>
      </div>
    </div>
    <div class="dt-page--2nd-bar" v-if="isSearchFilterActive">
      <div class="search-config--container">
        <div class="search-config">
          <SearchConBadge
            v-for="sconKey of filteredAdvancedSearchConfigKeys"
            :key="sconKey"
            v-bind="searchConfigKey(sconKey)"
            @delete="onSearchConDelete"
          />
        </div>
      </div>
    </div>
    <button
      :disabled="batchPDFDownloadLoading"
      @click="batchPDFDownloadRequest"
      class="dt-button v5 s8"
      :class="batchPDFDownloadLoading ? 'disabled' : ''"
      style="width: 100px; margin-left: 35px; margin-top: 10px"
      v-if="checkedInvoicesID.length > 0"
    >
      {{ $t("batch_pdf_download") }}
    </button>
    <div
      class="dt-page--body"
      :style="{ '--offset': `${isSearchFilterActive ? `156px` : `120px`}` }"
    >
      <NTable
        class="invoice-list h1"
        :config="tableConfig"
        ref="invoiceListTable"
        :headers="headers"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
        :id="'accounting-invoices-invoice_list'"
      >
        <template v-slot:thead="{ thcon, thtext }">
          <tr>
            <th
              v-for="header in headers"
              v-bind="thcon(header.value)"
              :key="header.value"
            >
              <div
                style="padding-bottom: 5px"
                v-if="['left_options'].includes(header.value)"
                class="header-name"
              >
                <div class="check-buttons">
                  <img
                    style="height: 18px; width: 18px"
                    @click="(e) => onHeaderCheckboxChanged(e)"
                    :src="`static/icons/arrows/${headerCheckboxIcon}-accent.svg`"
                    class="dt-icon checkbox"
                  />
                </div>
              </div>
              <span v-else class="header-name">
                {{ thtext(header.value) }}
              </span>
            </th>
          </tr>
        </template>

        <template v-slot:item="{ item, tdcon }">
          <tr
            @click="(e) => onInvoiceClicked(e, item)"
            :title="$t('click_to_see_invoice_details')"
            :class="{
              selected: selectedRow(item),
            }"
          >
            <td v-bind="tdcon('left_options')">
              <div class="dt-checkbox v2 s1" style="margin: auto 5px">
                <input
                  type="checkbox"
                  class="invoice-select-cb"
                  @click="(e) => onInvoiceCheckboxChange(e, 'invoice', item)"
                  :checked="checkedInvoicesID.includes(item.invoice_id)"
                />
                <div class="checkmark"></div>
              </div>
            </td>
            <td v-bind="tdcon('invoiceno_date')">
              <div class="ut-flex">
                <div
                  class="circle"
                  :style="{
                    backgroundColor: `${
                      item['color']
                        ? getInvoiceStatColor(item['color'])
                        : getInCoStatusColor(item['status_colour'])
                    }`,
                  }"
                ></div>

                <div
                  style="margin-left: 10px"
                  class="multilineLeft"
                  :title="item.invoice_ref"
                >
                  <span class="txtov" :title="item['invoice_ref']">{{
                    item["invoice_ref"]
                  }}</span>
                  <span class="txtov2" :title="item['invoice_date']">{{
                    item["invoice_date"]
                  }}</span>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('recipient_sender')">
              <div class="multilineLeft">
                <span class="txtov" :title="item['name']">{{
                  getContactName(item)
                }}</span>
                <span class="txtov2" :title="item['invoice_project_name']">{{
                  item["invoice_project_name"]
                }}</span>
              </div>
            </td>
            <!-- <td v-bind="tdcon('date')">
              <span class="txtov" :title="item['invoice_date']">{{
                item["invoice_date"]
              }}</span>
            </td>
            <td v-bind="tdcon('recipient')">
              <span class="txtov" :title="item['name']">{{
                getContactName(item)
              }}</span>
            </td> -->
            <td v-bind="tdcon('descriptions')" :title="item['subject']">
              <span class="txt-multiline-ov">{{ item["subject"] }}</span>
            </td>
            <td v-bind="tdcon('amount')">
              <div class="ut-jend">
                <div class="amount-text">
                  {{ item["gross_amount_cc"] || item["amount"] }}
                </div>
                <div class="amount-currency">
                  {{
                    item["currency_iso"] ||
                    item["currency"] ||
                    ($store &&
                      $store.getters &&
                      $store.getters.account &&
                      $store.getters.account.client &&
                      $store.getters.account.client.default_currency)
                  }}
                </div>
              </div>
            </td>
            <td v-bind="tdcon('forward')">
              <!-- -->
              <!--  -->
              <v-menu
                :close-on-content-click="false"
                open-on-hover
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                v-if="item.artist_invoice_forward_count > 0"
              >
                <div slot="activator">
                  <div class="dt-icon-container">
                    <img
                      src="static/icons/fast-forward.svg"
                      class="dt-icon v2 s16p"
                      :alt="$t('forwarding')"
                      :title="$t('forwarding')"
                      @mouseover="(e) => onFastHover(item['invoice_id'])"
                      @mouseleave="(e) => onFastLeave(item['invoice_id'])"
                    />
                  </div>
                </div>
                <div style="background-color: white">
                  <ForwardHoverPayments :artistPayments="hoverPayments" />

                  <!-- <div class="amount-text">{{item['gross_amount_cc']}}</div>
                        <div class="amount-currency">{{item['currency_iso']}}</div> -->
                </div>
              </v-menu>
            </td>
            <!-- <td v-bind="tdcon('status')">
              
            </td> -->
            <td v-bind="tdcon('options')">
              <div>
                <div class="actions">
                  <div class="dt-icon-container">
                    <img
                      v-if="
                        singlePDFDownloadingID > 0 &&
                        singlePDFDownloadingID == item.invoice_id
                      "
                      src="static/icons/loading.gif"
                      alt
                      style="height: 10px; width: 10px; margin: 0px 10px"
                    />
                    <img
                      v-else
                      @click.stop="(e) => onInvoicePDFClick(item)"
                      src="static/icons/pdf.svg"
                      class="dt-icon v5 s2"
                      alt
                      :title="`${$t('pdf')}`"
                    />
                  </div>
                  <div class="dt-icon-container">
                    <img
                      @click.stop="(e) => onInvoiceMailClick(item)"
                      src="static/icons/email/email-grey.svg"
                      class="dt-icon v5 s2"
                      :alt="$t('mail_invoice')"
                      :title="$t('mail_invoice')"
                    />
                  </div>
                  <div class="dt-icon-container">
                    <img
                      @click.stop="(e) => onInvoicePrintClick(item)"
                      src="static/icons/printer.svg"
                      class="dt-icon v5 s2"
                      alt
                      :title="`${$t('print')}`"
                    />
                  </div>
                  <div class="dt-icon-container">
                    <img
                      @click.stop="(e) => onInvoiceEditClick(item)"
                      src="static/icons/edit.svg"
                      class="dt-icon v5 s2"
                      :alt="$t('set_invoice_status')"
                      :title="$t('set_invoice_status')"
                    />
                  </div>
                </div>
                <div class="dt-icon-container">
                  <img
                    v-if="item['lock_flag'] == '1'"
                    @click.stop="(e) => onInvoiceLockClick(item)"
                    src="static/icons/booking/lock-closed.svg"
                    class="dt-icon v5 s2"
                    :alt="$t('unlock_invoice')"
                    :title="$t('unlock_invoice')"
                  />
                  <div
                    v-if="item['lock_flag'] == 'LOADING'"
                    class="loading-icon-container"
                  >
                    <img
                      @click.stop="(e) => onInvoiceLockClick(item)"
                      src="static/icons/loading.gif"
                      class="loading-icon dt-icon v5 s2"
                      :alt="$t('loading')"
                      :title="$t('loading')"
                    />
                  </div>
                  <img
                    v-if="
                      item['lock_flag'] == null ||
                      item['lock_flag'] == '0' ||
                      item['lock_flag'] == undefined
                    "
                    @click.stop="(e) => onInvoiceLockClick(item)"
                    src="static/icons/booking/lock-open.svg"
                    class="dt-icon v5 s2"
                    :alt="$t('lock_invoice')"
                    :title="$t('lock_invoice')"
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <DtPageStatusFloat
      :statusTV="
        inv_statTV.map((tv) => ({
          ...tv,
          text: $t(tv.text),
          value: `${getInvoiceStatColor(tv.value)}`,
        }))
      "
    />

    <Sidewindow
      :navConfig="defaultConfig"
      :value="invoiceDetailsFlag"
      @closed="onCloseInvoiceDetails"
    >
      <InvoiceSidewindow :invoice="selectedInvoice"></InvoiceSidewindow>
    </Sidewindow>

    <ModalContainer :modalKey="'setStatus'" :width="'420'">
      <SetStatus
        :invoice="invoice_setstat"
        :currencies="currencies"
        @cancelled="onsetStatusCancelled"
        @done="onSetStatusDone"
        @sendRoyaltyPeriods="getRoyaltyPeriods"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'royaltyPeriodModal'" :width="'small2'">
      <RoyaltyPeriodModal
        :royaltyPeriods="royaltyPeriods"
        @cancelled="onsetStatusCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'advancedSearch'" width="small">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @cancelled="onAdvancedSearchCancelled"
      />
    </ModalContainer>

    <template v-if="addInvoiceModalContainer">
      <v-dialog v-model="addInvoiceModal" persistent width="390">
        <AddInvoice
          :invoice_projectsTV="invoice_projectsTV"
          :currencyTV="currencyTV"
          :defaultCurrency="$store.getters.account.client.default_currency"
          @created="onInvoiceCreated"
          @cancelled="onaddInvoiceCancelled"
        />
      </v-dialog>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { LDTHost } from "@/dt-plugins/sidewindow";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime, window } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";
// import Sidewindow from '../../../../plugins/sidewindow/sidewindow';
import { SharingSettingsService } from "../../../settings/services/sharing-settings.service";

import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { AccountingStoreNamespace as storeNS } from "../../store";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import {
  mapKeyToAction,
  mapGetterObject,
  mapActionObject,
} from "../../../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";

import InvoiceSidewindow from "./invoice-sidewindow";
import SetStatus from "./invoice-status";
import AddInvoice from "./add-invoice";
import RoyaltyPeriodModal from "./royalty-period-modal.vue";
import { createCountriesTV } from "../../../../models/country.model";
import {
  openWindow,
  createMailHref,
  downloadPDF,
  toSnakeCase,
  wait,
} from "../../../../utility";
import { InvoicesService } from "../../services/invoices.service";
import {
  invoiceListLDTRoutes,
  getInvoiceDetailsSelectable,
} from "../../router/routes";
import { HttpClient } from "../../../../services/http/http-client";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import {
  showNotification,
  showError,
} from "../../../../dt-plugins/notification/notification.service";
import { invoiceGetters } from "../../store/invoices/getters";
import { invoiceActions } from "../../store/invoices/actions";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { InvoiceForwardService } from "../../services/invoice-forward.service";
import ForwardHoverPayments from "./forward-payments-hover";
import {
  getInCoStatusColor,
  getInvoiceStatColor,
} from "../../models/color-status";
import DtPageStatus from "@dtplugins/dtpage-status/dtpage-status";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import { ContactFuncs } from "../../../contacts/models/contacts.model";
import { BookingStoreNamespace } from "../../../booking/store";
import * as ActionTypesBooking from "../../../booking/store/types";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { createSubmoduleListMixin } from "../../../../dt-plugins/submodule-list/submodule-list.mixin";
import { NotificationService } from "@dtplugins/notification/notification.service";

import AdvancedSearch, {
  invoiceListAdvancedSearchConfig,
} from "./advanced-search.vue";

const listLength = 100;

const LDTConfig = {
  entityName: "invoice",
  ldtRoutes: invoiceListLDTRoutes,
  detailsSelectableFunction: getInvoiceDetailsSelectable,
  primaryKey: "invoice_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.InvoiceDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.InvoiceDetails.FETCH.SINGLE,
};

export default {
  components: {
    ModalContainer,
    NTable,
    InputField,
    LDTHost,
    InvoiceSidewindow,
    DtPageStatus,
    DtPageStatusFloat,
    SetStatus,
    AddInvoice,
    ForwardHoverPayments,
    RoyaltyPeriodModal,
    AdvancedSearch,
  },
  mounted: async function () {
    // this.$nextTick(() => {
    //   this.$refs?.["invoiceListTable"]?.setScrollTop(
    //     this.invoice_list_scrolltop
    //   );
    // });

    this.fetchData();

    // //Stop Refetching on Mounted -- Usually Unnecessary
    // if (this.list?.length == 0) {
    //   this.fetchList();
    // }

    // subscribeSubject(this, this.searchSubject$, (search_str) => {
    //   // this.searchList(search_str);
    //   this.fetchList();
    // });
    // subscribeSubject(this, this.scrollSubject$, (scrollTop) => {
    //   // console.log(
    //   //   "this.invoice_list_start_from::::",
    //   //   this.startFrom,
    //   //   this.invoice_list_start_from
    //   // );
    //   if (this.invoice_list_start_from == this.invoiceListFilter.start_from) {
    //     this.fetchListNext({
    //       start_from: this.invoiceListFilter.start_from + listLength,
    //     });
    //   }
    // });
  },
  data: function () {
    return {
      defaultConfig: defaultConfig,
      getInvoiceDetailsSelectable: getInvoiceDetailsSelectable,
      royaltyPeriods: [],
      countries: [],
      groups: [],

      // startRow: 0,

      searchSubject$: new Subject(),
      search_str: "",

      // invoice_project_id: null,
      // invoice_user_id: null,
      // invoiceStatuses: "",

      // startFrom: 0,
      // scrollSubject$: new Subject(),

      LDTHostConfig: {
        itemKey: "invoice",
      },

      invoice_setstat: null,
      selectedClickedInvoice: null,

      hoverFlag: false,
      hoverPayments: [],

      checkedInvoicesID: [],
      batchPDFDownloadLoading: false,

      singlePDFDownloadingID: 0,

      // start: "",
      // end: "",
      // start_payment: "",
      // end_payment: "",
      // status_textkey: "0,1",
      // invoice_project_ids: "456,234",
      // subject: "",
      // amount: "",
      // // pdf: "",
      // invoice_ref: "",
      // recipient: "",

      // loadingFlag: false,
    };
  },
  mixins: [
    createLDTHost(LDTConfig),
    createModalMixin("setStatus"),
    createModalMixin("addInvoice"),
    createModalMixin("royaltyPeriodModal"),
    // FetchList and Advanced Search Mixin

    createModalMixin("advancedSearch"),
    createFetchListMixin(ActionTypes.InvoiceList.FETCH.ALL),
    createAdvancedSearchHost(invoiceListAdvancedSearchConfig, {
      onBeforeAdvancedSearchFetch: "onBeforeAdvancedSearchFetch",
    }),
    createSubmoduleListMixin("invoice"),
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetterObject(storeNS, invoiceGetters),
    ...mapGetters(storeNS, {
      list: "invoiceList",
    }),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 48,
      });
    },
    headers: function () {
      return [
        createTableHeader("left_options", { mw: 25, ta: "center" }),
        createTableHeader("invoiceno_date", { f: 1.1, fw: 700 }),
        createTableHeader("recipient_sender", { f: 0.9 }),

        // createTableHeader("date", { f: 0.4, minw: 90 }),
        // createTableHeader("recipient", { f: 0.8 }),
        createTableHeader("descriptions", { f: 1.7 }),
        createTableHeader("amount", { f: 0.5, minw: 120 }),
        createTableHeader("forward", {
          text: false,
          ta: "center",
          mw: 40,
        }),
        // createTableHeader("status", { mw: 50, ta: "center" }),
        createTableHeader("options", { text: false, mw: 165 }),
      ];
    },
    invoiceDetailsFlag: function () {
      return childOfOrEqualDetails(invoiceListLDTRoutes, this.$route);
    },
    countriesTV: function () {
      return createCountriesTV(this.countries);
    },
    // updateFilter() {},
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
    // filter: function () {
    //   const no_filter_selected = Object.values(this.searchFilter)?.every(
    //     (e) => !e
    //   );

    //   let searchType = this.searchType;
    //   if (!no_filter_selected && this.searchType == "none") {
    //     searchType = "standard_search";
    //   }

    //   return {
    //     searchType,
    //     no_filter_selected,

    //     search_str: this.basicFilter.searchString,
    //     invoiceStatuses: this.basicFilter.invoiceStatuses,
    //     invoice_project_id: this.basicFilter.invoice_project_id,
    //     invoice_user_id: this.basicFilter.invoice_user_id,

    //     start: this.start,
    //     row_count: this.row_count,

    //     ...this.searchFilter,
    //   };
    // },
    // filter: function () {
    //   return {
    //     search_str: this.search_str,
    //     invoiceStatuses: this.invoiceStatuses,
    //     invoice_project_id: this.invoice_project_id,
    //     invoice_user_id: this.invoice_user_id,
    //   };
    // },
    paginatedFilter: function () {
      return {
        search_str: this.search_str,
        invoiceStatuses: this.invoiceStatuses,
        invoice_project_id: this.invoice_project_id,
        invoice_user_id: this.invoice_user_id,
        start_from: this.startFrom,
      };
    },
    selectedInvoice: function () {
      //console.log("EWRT", this.invoiceDetails[this.$route.params.invoice_id]);
      return this.invoiceDetails[this.$route.params.invoice_id] || {};
    },

    // FetchList and Advanced Search Computed
    advancedSearchData: function () {
      // console.log(
      //   this.invoice_statusTV.map((e) => ({
      //     ...e,
      //     text: this.$t(e.value),
      //   }))
      // );
      return {
        invoice_projectsTV: this.invoice_projectsTV,
        invoice_statusTV: this.invoice_statusTV.map((e) => ({
          ...e,
          text: this.$t(e.text),
        })),
      };
    },

    headerCheckboxIcon: function () {
      return this.checkedInvoicesID.length == this.list.length
        ? "checkbox-tick"
        : this.checkedInvoicesID.length == 0
        ? "checkbox"
        : "checkbox-minus";
    },
  },
  methods: {
    toSnakeCase: toSnakeCase,
    ...mapActions(BookingStoreNamespace, {
      [ActionTypesBooking.FETCH_BOOKING_OVERVIEW_INVOICES]:
        ActionTypesBooking.FETCH_BOOKING_OVERVIEW_INVOICES,
    }),
    ...mapActionObject(storeNS, invoiceActions),
    ...mapMutations(storeNS, {
      [ActionTypes.UPDATE_INVOICE_LIST_SCROLLTOP]:
        ActionTypes.UPDATE_INVOICE_LIST_SCROLLTOP,
    }),

    // FetchList and Advanced Search Methods
    defaultBasicFilter() {
      return {
        searchString: "",
        invoice_project_id: null,
        invoice_user_id: null,
        invoiceStatuses: "",
      };
    },

    getInvoiceStatColor: getInvoiceStatColor,
    getInCoStatusColor: getInCoStatusColor,

    fetchData: function () {
      this[ActionTypes.InvoiceData.FETCH.ALL]();
    },
    // fetchList: async function (payload = {}) {
    //   this.loadingFlag = true;
    //   await this[ActionTypes.InvoiceList.FETCH.ALL]({
    //     start_from: 0,
    //     ...payload,
    //   });
    //   this.loadingFlag = false;
    // },
    // fetchListNext: function (payload) {
    //   this[ActionTypes.InvoiceList.FETCH.ALL](payload);
    // },

    onFastHover: async function (invoice_id) {
      const Payments = await InvoiceForwardService.getInvoiceTabForward(
        invoice_id
      );
      this.hoverPayments = Payments.data.artist_payments;
      // console.log("ID", this.hoverPayments);
    },
    onFastLeave: function (invoice_id) {
      // console.log("ID Leave", invoice_id);
      // InvoiceForwardService.getInvoiceTabForward(invoice_id)
      //invo
    },
    searchList: function () {
      // console.log("Log: this.invoiceStatuses", this.invoiceStatuses)
      // console.log(`Log: (this.invoiceStatuses && this.invoiceStatuses.length > 0)
      //     ? this.invoiceStatuses.map(e => e.value).join()
      //     : undefined`, (this.invoiceStatuses && this.invoiceStatuses.length > 0)
      //     ? this.invoiceStatuses.map(e => e.value).join(',')
      //     : undefined);
      // console.log("Log: this.invoice_project_id", this.invoice_project_id)
      // console.log("Log: this.invoice_user_id", this.invoice_user_id)

      this[ActionTypes.InvoiceList.SEARCH.ALL](this.filter);
    },

    onInvoiceMailClick: async function (item) {
      // console.log(item);
      await sendInvoiceMail(item);
      this.onInvoiceLockClick(item);
    },
    onInvoicePDFClick: async function (item) {
      if (this.singlePDFDownloadingID > 0) {
        return;
      }

      const { invoice_id, invoice_ref } = item;
      this.singlePDFDownloadingID = invoice_id;

      const filename = `${invoice_ref}.pdf`;
      const printURL = `${HttpClient.getBaseUrl()}/accounting.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`;

      await downloadPDF(printURL, this.$store.getters.account, filename);
      this.singlePDFDownloadingID = 0;
    },
    onInvoicePrintClick: async function (item) {
      const { invoice_id } = item;

      // await this.onInvoiceLockClick(item);
      if (+item["lock_flag"] != 1) {
        this[ActionTypes.LOCK_INVOICE]({
          from: "list",
          item: {
            invoice: item,
          },
        });
      }

      openWindow(
        `${HttpClient.getBaseUrl()}/accounting.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`,
        "Print Invoice",
        { wr: 0.7, hr: 0.7 }
      );

      // window.open(
      //   `${HttpClient.getBaseUrl()}accounting.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`
      // );
      // console.log(`${HttpClient.getBaseUrl()}?section=invoices&action=print_invoice&invoice_id=${invoice_id}`);
    },
    getRoyaltyPeriods: function (royaltyPeriods) {
      this.royaltyPeriods = [...royaltyPeriods];
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: "royalty_period_modal",
        },
      });
    },
    onInvoiceEditClick: function (item) {
      // this.invoice_setstat = item;
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: "set_status",
          invoice_id: item.invoice_id,
        },
      });
    },
    onInvoiceLockClick: function (item) {
      this[ActionTypes.LOCK_INVOICE]({
        from: "list",
        item: {
          invoice: item,
        },
      });
    },
    // onInvoiceProjectSelect: function (event) {
    //   // this.invoice_project_id = event.value;

    //   this.fetchList({
    //     invoice_project_id: event.value,
    //   });
    // },
    // onInvoiceUserSelected: function (event) {
    //   // this.invoice_user_id = event.value;
    //   // console.log({ "this.invoice_user_id": this.invoice_user_id });
    //   // this.fetchList();
    //   this.fetchList({
    //     invoice_user_id: event.value,
    //   });
    // },
    // onInvoiceStatusSelected: function (event) {
    //   this.basicFilter['invoiceStatuses'] = event?.length > 0 ? event?.map((e) => e.value).join(",") : "";

    //   // console.log({ "invoice-list.vue:625 event": event });

    //   // this.invoiceStatuses =
    //   //   event?.length > 0 ? event?.map((e) => e.value).join(",") : "";
    //   // console.log({
    //   //   "invoice-list.vue:628 this.invoiceStatuses": this.invoiceStatuses,
    //   // });
    //   // this.fetchList({
    //   //   invoiceStatuses:
    //   //     event?.length > 0 ? event?.map((e) => e.value).join(",") : "",
    //   // });
    //   // this.fetchList();
    // },
    onInvoiceClicked: function (e, invoice) {
      // console.log({
      //   name: invoiceListLDTRoutes.names.tab,
      //   params: {
      //     id: invoice.invoice_id,
      //     tab: 'overview'
      //   }
      // });
      // console.log("INVICE THAT WAS SENT", invoice);
      // console.log('mdsir e:', e.target.className);
      if (
        ["left_options", "dt-checkbox v2 s1", "invoice-select-cb"].includes(
          e.target.className
        )
      ) {
        return;
      }

      this.selectedClickedInvoice = invoice;
      this.$router.push({
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: invoice.invoice_id,
          tab: "overview",
        },
      });
    },
    onInvoiceCheckboxChange: function (e, type, item) {
      const checked = e.target.checked;

      if (type == "invoice") {
        if (checked) {
          this.checkedInvoicesID = [...this.checkedInvoicesID, item.invoice_id];
        } else {
          this.checkedInvoicesID = this.checkedInvoicesID.filter(
            (r) => r != item.invoice_id
          );
        }
      }
    },
    batchPDFDownloadRequest: async function (e, type, item) {
      const invoice_ids = this.checkedInvoicesID.join();
      // console.log('mdsir: invoice_ids', invoice_ids);
      this.batchPDFDownloadLoading = true;
      const { domain_tld } = HttpClient.getBaseURLObject();
      const res = await InvoicesService.batchPDFDownload({
        type: "invoice",
        ids: invoice_ids,
        domain_tld,
      });
      NotificationService.showNotification({
        text: this.$t('pdf_download_processing_message'),
        timeout: 10000,
      });
      this.batchPDFDownloadLoading = false;
    },
    onHeaderCheckboxChanged(e) {
      if (this.headerCheckboxIcon == "checkbox-tick") {
        this.checkedInvoicesID = [];
      } else {
        this.checkedInvoicesID = this.list.map((r) => r.invoice_id);
      }
    },
    // onInvoiceScrollNext: function (value) {
    //   console.log("value :::", value);
    //   // if (this.invoice_list_start_from == this.startFrom) {
    //   //   this.startFrom += listLength;
    //   //   this.fetchListNext();
    //   // }
    //   if (this.invoice_list_start_from == this.invoiceListFilter.start_from) {
    //     this.fetchListNext({
    //       start_from: this.invoiceListFilter.start_from + listLength,
    //     });
    //   }
    //   //this.scrollSubject$.next(value);
    // },
    onsetStatusCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined,
        },
      });
    },
    onSetStatusDone: async function ([command, arg]) {
      // console.log({ "invoice-list.vue:673 [command, arg]": [command, arg] });
      // console.log({ "invoice-list.vue:675 this.$route": this.$route });
      // If it calendar date related invoice then update the booking overview invoices by fetch from server.
      if (this.selectedInvoice?.invoice?.external_table == "calendar_dates") {
        await this[ActionTypesBooking.FETCH_BOOKING_OVERVIEW_INVOICES]({
          calendarDateId: this.selectedInvoice.invoice.external_id,
        });
      }

      this.onsetStatusCancelled();
      if (command === "refresh") {
        if (this.$route.name === invoiceListLDTRoutes.names.list) {
          this.fetchList();
          if (arg) {
            const invoice_id = arg;
            // If the Invoice Details Is open in a tab, Refresh the Single Invoice Details Object
            // console.log(this.invoiceDetails, invoice_id);
            if (this.invoiceDetails[invoice_id]) {
              this[ActionTypes.InvoiceDetails.FETCH.SINGLE]({
                flag: false,
                invoice: {
                  invoice_id,
                },
                reload: true,
              });
            }
          }
        } else if (this.$route.name === invoiceListLDTRoutes.names.tab) {
          if (this.selectedInvoice.invoice) {
            this[ActionTypes.InvoiceDetails.FETCH.SINGLE]({
              flag: true,
              invoice: this.selectedInvoice.invoice,
              reload: true,
            });
          }
        }
      } else if (command === "redirect") {
        this.$router.push({
          name: invoiceListLDTRoutes.names.tab,
          params: {
            invoice_id: arg,
            tab: "overview",
          },
        });
      } else if (command === "list") {
        this.$router.push({
          name: invoiceListLDTRoutes.names.list,
        });
        this.refresh();
      } else if (command === "delete") {
        // Find the Invoice From the getter invoiceDetails
        // Remove it from the invoiceDetails
        const invoice_id = arg;
        console.log(
        "DELETE Command this.invoiceDetails?.[invoice_id]",
        this.invoiceDetails?.[invoice_id]
        );
        if (this.invoiceDetails?.[invoice_id]) {
          console.log("DELETE Command this.invoiceDetails?.[invoice_id]", this.invoiceDetails?.[invoice_id])
          this[ActionTypes.InvoiceDetails.DELETE.SINGLE]({
            invoice_id,
          });
        }
      } else if (command === "back") {
        // console.log({
        // "invoice-list.vue:721 command": command,
        // r: this.$route.$route,
        // });
        // console.log({ "invoice-list.vue:724 this.$route": this.$route });

        handleFromRoute(this, () => {
          // console.log({
          // "invoice-list.vue:724 this.$router.back()": this.$route,
          // });
          this.$router.push({
            name: invoiceListLDTRoutes.names.list,
          });
        });
      }
    },
    onCloseInvoiceDetails: function () {
      this.selectedClickedInvoice = null;
      this.refresh();
      handleFromRoute(this, () => {
        this.$router.push({
          name: invoiceListLDTRoutes.names.list,
        });
      });
    },
    onAddInvoiceClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_invoice",
        },
      });
    },
    onaddInvoiceCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onInvoiceCreated: async function (invoice) {
      this.fetchList();
      this.onaddInvoiceCancelled();
      console.log({ "invoice-list.vue:1100 invoice": invoice });
      await wait(1000);

      this.selectedClickedInvoice = invoice;
      this.$router.push({
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: invoice.invoice_id,
          tab: "overview",
        },
      });
    },
    onDrawerKeyup: function (event) {
      // console.log(event);
    },

    // onSearchInputKeyup: function (event) {
    //   const search_str = event.target.value;
    //   this[ActionTypes.InvoiceListFilter.UPDATE.ALL]({
    //     search_str: search_str,
    //   });
    //   this.searchSubject$.next(search_str);
    // },
    selectedRow: function (invoice) {
      return (
        this.selectedClickedInvoice &&
        this.selectedClickedInvoice["invoice_id"] == invoice["invoice_id"]
      );
    },
    refresh: async function () {
      await this.fetchList();
      this.$refs["invoiceListTable"].resetScroll();
    },
    getContactName: ContactFuncs.getName,
    onInvoiceListScrolled(event) {
      // console.log("Invoice List Scrolled", event.target.scrollTop);
      this[ActionTypes.UPDATE_INVOICE_LIST_SCROLLTOP](event.target.scrollTop);
    },

    isLocal() {
      // console.log('this.$route?.name', this.$route?.name);
      // return true;
      return /(localhost)|(192.168)/.test(window.location.origin);
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    onBeforeAdvancedSearchFetch: function () {
      this.resetBasicFilter();
    },

    fetchAdvancedSearchData: async function () {
      // const advancedSearchData =
      //   await ProductsService.fetchAdvancedSearchData();
      // this.advancedSearchResponse = advancedSearchData.data;
      // console.log(
      //   "this.advancedSearchResponse",
      //   this.advancedSearchResponse,
      //   "this.advancedSearchResponse"
      // );
    },

    //MARK: Methods
  },
};

export const sendInvoiceMail = async (invoice) => {
  // console.log("Log: sendInvoiceMail -> invoice", invoice);
  const { invoice_id, invoice_contact_email } = invoice;
  // console.log("Log: invoice_contact_email", invoice_contact_email);
  const paypalResult = await InvoicesService.getPaypalModal({
    invoice_id,
  }).then((res) => res.data);

  if (
    paypalResult.hasPaypalEmail == "1" &&
    !paypalResult.paypalPaymentEnabled
  ) {
    const confirmationResult = await ConfirmationService.createP({
      width: "550px",
      body: `
      <div class="h00" style="margin-bottom:5px;height:100px; padding-left: 3px;">
            Do you want to allow the recipient to pay this invoice using Paypal?<br><br>

            YES will include a Paypal Payment option to the invoice<br>
            NO, DISPLAY ONLY will not include that option<br>
            CANCEL will cancel this action<br>
        </div>
        `,
      results: [
        createConfirmResult({
          value: "no",
          text: "No, Display Only",
        }),
        createConfirmResult({
          value: "Cancel",
        }),
        createConfirmResult({
          value: "yes",
          text: "Yes",
          classes: ["v1"],
        }),
      ],
    });
    if (confirmationResult === "yes") {
      const includePaypalOption = await InvoicesService.includePaypalOption({
        invoice_id,
      }).then((res) => res.data);
      // console.log("Log: includePaypalOption", includePaypalOption);

      if (includePaypalOption.actionStatus == "done") {
        showNotification("Included Paypal Payment option");
        await emailInvoiceReminder(invoice_id, invoice_contact_email);
      } else {
        showError("Paypal Payment option could not be included");
      }
    } else if (confirmationResult === "no") {
      showNotification("Display Only");
      await emailInvoiceReminder(invoice_id, invoice_contact_email);
    }
  } else {
    // console.log(paypalResult.data);
    // const invoiceReminder = await InvoicesService.getInvoiceReminder({
    //   invoice_id
    // });
    // // console.log(invoiceReminder.data, invoiceReminder.data.invoice_email_text);

    // sendMail({
    //   body: invoiceReminder.data.invoice_email_text,
    //   mails: [invoiceReminder.data.email]
    // });
    await emailInvoiceReminder(invoice_id, invoice_contact_email);
  }
};

const emailInvoiceReminder = async (invoice_id, email) => {
  const invoiceReminder = await InvoicesService.getInvoiceReminder({
    invoice_id,
  });
  // console.log(
  // ":::::::::::",
  // invoiceReminder.data,
  // invoiceReminder.data.invoice_email_text
  // );
  // sendMail({
  //   subject:'',
  //   body: invoiceReminder.data.invoice_email_text,
  //   mails: [email ? email : invoiceReminder.data.email],
  // });

  //location.href = `mailto:${email ? email : invoiceReminder.data.email}?subject=${sub}&body=${invoiceReminder.data.invoice_email_text}`;

  location.href = createMailHref({
    subject: "",
    body: invoiceReminder.data.invoice_email_text,
    mails: [email ? email : invoiceReminder.data.email],
  });
};
</script>

<style lang="scss">
.cmp-accounting-invoices-invoice_list {
  // .dt-page--data-table {
  //   --offset: 135px;
  // }

  .dt-ntable.invoice-list {
    th:first-child,
    td:first-child {
      flex: 0.6;
    }
    .forward {
    }
    .status {
      .status-container {
        display: flex;
        flex-direction: row;
        .menu {
          // margin-left: 10px;
          // margin-top: -1px;
        }
      }
    }
    th:nth-child(7),
    td:nth-child(7) {
      // .circle {
      //   width: 16px;
      //   height: 16px;
      //   border-radius: 50px;
      // }
    }

    td.options {
      div {
        display: flex;
        flex-direction: row;
        img {
          flex: 1;
        }
        .loading-icon-container {
          flex: 1;
          .loading-icon {
            max-width: 15px;
            max-height: 15px;
            margin-top: 10px;
            margin-left: 16px;
          }
        }
      }
    }
    td.status {
      //  display: flex;
      //  justify-content: center;
      //flex-direction: row;
      div {
        margin: 0 auto;
      }
    }
    th {
      &.amount {
        span {
          text-align: right !important;
        }
      }
    }
    td.amount {
      div {
        display: flex;
        .amount-text,
        .amount-currency {
          display: flex;
          flex-direction: column;
          justify-content: center;
          // text-align: right;
        }
        .amount-text {
          // flex: 1 1 10px;
        }
        .amount-currency {
          width: 30px;
          padding-left: 5px;
        }
      }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(5),
      td:nth-child(5),
      th:nth-child(7),
      td:nth-child(7),
      th:nth-child(8),
      td:nth-child(8) {
        display: none;
      }
    }

    tbody {
      padding-bottom: 48px;
    }
  }

  td .phone-icon {
    display: none;
  }
  td .phone-no {
    display: inherit;
  }

  @media (min-width: 1281px) {
  }
  @media (min-width: 1025px) and (max-width: 1280px) {
  }
  @media (min-width: 768px) and (max-width: 1024px) {
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
  @media (min-width: 481px) and (max-width: 767px) {
  }
  @media (min-width: 768px) and (max-width: 1024px) {
  }
  @media (min-width: 320px) and (max-width: 480px) {
  }
  @media (min-width: 320px) and (max-width: 375px) {
  }
}
</style>
